module.exports = __webpack_public_path__ + "static/media/video-slider.7828d1d5.png";